<template>
    <div class="platform-container">
        <!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 370.71 277.49" enable-background="new 0 0 127.4 132.7" xml:space="preserve">
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <path class="cls-1" d="M279.8,179.07c0,6.15-7.8,9.44-7,16.9,1.11,10.89,19.61,22.26,23,24.33,1.56.95,4.13,2.42,5.4,5.4,1.92,4.52-1.2,7.69.68,10.81,2.48,4.13,9.89,1.89,10.81,4.73s-5.69,7.9-9.46,10.14c-2.68,1.58-3.94,1.77-7.43,4.05a28.28,28.28,0,0,0-6.08,4.73c-4.66,5.32-1.52,10.41-4.73,14.19s-9.62,2.87-20.27,1.35c-14.07-2-15-4.92-25-5.4-12.14-.59-14.8,3.51-19.6.67-9.21-5.45-3.48-23-10.81-26.35-7.54-3.49-15.68,14.09-29.05,12.16-11.35-1.63-14.88-15.63-27.71-15.54-2.43,0-6.73.56-8.78-2-1.51-1.9-1.19-4.69-.68-6.76a28.11,28.11,0,0,1-5.14.52"/>
                    <path class="cls-1" d="M123.41,221c-1.52-7.23-1.08-16.25-8.08-23.65-5.42-5.73-14.83-10-19.59-6.75-2.92,2-1.59,7-3.38,7.43-2.42.58-6.75-7.77-9.46-14.87-4.39-11.47-.16-17-5.41-25.67a37.14,37.14,0,0,0-5.4-6.76c-5.54-5.62-8.69-5.66-12.84-9.46-.47-.43-9.35-8.76-8.11-17.57,1.31-9.27,13-13.48,11.49-17.56-1.13-3-7.9-2.25-8.11-4.06-.33-2.81,15.84-6.48,15.54-8.1-.23-1.25-9.47,2.19-16.22-2C48.79,88.75,49.51,84,43.71,65.57c-4-12.7-5.45-14-5.41-19.6.07-9.75,4.58-20.22,8.79-20.27C52,25.65,52.76,39.84,62,42.59a13.3,13.3,0,0,0,11.49-2c2.75-2.21,2.08-4.22,4.73-6.76,4.59-4.4,13.25-4.75,14.86-2S87.75,39.5,89.66,44c1.11,2.59,3.87,1.84,7.43,4.72,4.59,3.73,2.71,7.16,7.43,14.87,1.7,2.77,5.17,8.28,11.49,10.81a19.52,19.52,0,0,0,6.75,1.35c18.73,1,37.88,11.21,42.57,5.41a13.91,13.91,0,0,0,3.21-7.54c0-1-.13-1.4.17-1.92,1.37-2.4,7.95.1,12.84,0,10.62-.23,11.8-12.77,21.62-15.54,11.33-3.2,16.32,11.64,41.89,20.27,13.73,4.63,19.45,2.77,22.3,8.11,4.78,9-9.14,18.25-5.41,34.46,1.08,4.7,3.63,9.87,2,16.21a31.08,31.08,0,0,0-1.35,8.11,30.72,30.72,0,0,0,.67,6.76,43.93,43.93,0,0,0,5.41,14.86,24.66,24.66,0,0,0,3.82,4.86"/>
                    <path class="cls-1" d="M202.5,260.16c-3.26-.52-5.65,1.3-10.46.61-.45-.06-.9-.15-1,.06-.48.8,3.67,6.1,9.46,6.76a12.36,12.36,0,0,0,8.78-2.7C206.66,261.47,204.26,260.44,202.5,260.16Z"/>
                    <rect class="cls-2" x="335.95" y="33.97" width="34.26" height="66.79" rx="3" ry="3"/>
                    <rect class="cls-3" x="343.02" y="95.43" width="20.38" height="2.25" rx="1.12" ry="1.12"/>
                    <path class="cls-4" d="M363.4,34v2.08a1.15,1.15,0,0,1-1.16,1.13H344.18A1.15,1.15,0,0,1,343,36.05V34Z"/>
                    <path class="cls-2" d="M137.89,223.49v50.94a2.52,2.52,0,0,1-2.52,2.52H111.69a2.52,2.52,0,0,1-2.51-2.52V223.49a2.53,2.53,0,0,1,2.51-2.52h23.68A2.53,2.53,0,0,1,137.89,223.49Z"/>
                    <circle class="cls-3" cx="123.54" cy="269.86" r="2.57"/>
                    <rect class="cls-2" x="18.68" y="145.75" width="27.38" height="53.38" rx="2.4" ry="2.4"/>
                    <rect class="cls-2" x="24.33" y="194.88" width="16.29" height="1.8" rx="0.9" ry="0.9"/>
                    <path class="cls-2" d="M40.62,145.75v1.67a.92.92,0,0,1-.93.9H25.25a.92.92,0,0,1-.92-.9v-1.67Z"/>
                    <path class="cls-2" d="M328.17,153v23.54a2.51,2.51,0,0,1-2.5,2.5H275a2.5,2.5,0,0,1-2.5-2.5V153a2.5,2.5,0,0,1,2.5-2.5h50.64A2.51,2.51,0,0,1,328.17,153Z"/>
                    <circle class="cls-3" cx="323.19" cy="165.33" r="2.56"/>
                    <rect class="cls-2" x="190.42" y="0.5" width="25" height="48.75" rx="2.19" ry="2.19"/>
                    <line class="cls-2" x1="215.77" y1="43.62" x2="190.77" y2="43.62"/>
                    <line class="cls-2" x1="215.77" y1="2.77" x2="190.77" y2="2.77"/>
                    <rect class="cls-2" x="200.93" y="46.03" width="5.48" height="1.17" rx="0.58" ry="0.58"/>
                    <rect class="cls-2" x="0.5" y="18.06" width="19.62" height="38.24" rx="1.72" ry="1.72"/>
                    <rect class="cls-2" x="4.55" y="53.25" width="11.67" height="1.29" rx="0.64" ry="0.64"/>
                    <path class="cls-2" d="M16.22,18.06v1.19a.66.66,0,0,1-.67.64H5.21a.66.66,0,0,1-.66-.64V18.06Z"/>
                    <rect class="cls-2" x="189.32" y="141.17" width="19.62" height="38.24" rx="1.72" ry="1.72"/>
                    <rect class="cls-2" x="193.37" y="176.37" width="11.67" height="1.29" rx="0.64" ry="0.64"/>
                    <path class="cls-2" d="M205,141.17v1.2a.66.66,0,0,1-.67.64H194a.66.66,0,0,1-.66-.64v-1.2Z"/>
                    <path class="cls-5" d="M137.12,117.94h-6.46a5.07,5.07,0,0,1-4.94-5.18,5.69,5.69,0,0,1,2.93-4.89l.26-.13v-.3c0-.06,0-.12,0-.18v-.18a.49.49,0,0,1,0-.12,3.27,3.27,0,0,1,3.19-3.34,3,3,0,0,1,.42,0h.11a2.37,2.37,0,0,1,.36.09h0a2.5,2.5,0,0,1,.38.15l.1,0a3.31,3.31,0,0,1,1.78,3,.47.47,0,0,0,.46.48.46.46,0,0,0,.45-.48,4.34,4.34,0,0,0-1.45-3.27,6.78,6.78,0,0,1,12.36,3.7,8.07,8.07,0,0,0-1.86.06.47.47,0,0,0-.38.54.46.46,0,0,0,.45.41h.07a7.94,7.94,0,0,1,2.13,0,4.83,4.83,0,0,1,3.72,4.76,4.69,4.69,0,0,1-4.57,4.79h-9.55Z"/>
                    <path class="cls-5" d="M113.11,203a5.5,5.5,0,0,0-4.67,8.39l4.36,7a.44.44,0,0,0,.39.22h0a.47.47,0,0,0,.39-.22l4.26-7.1a5.58,5.58,0,0,0,.77-2.82A5.51,5.51,0,0,0,113.11,203Zm3.94,7.85-3.87,6.45-4-6.39a4.58,4.58,0,1,1,8.48-2.41A4.62,4.62,0,0,1,117.05,210.85Z"/>
                    <path class="cls-5" d="M113.11,205.75a2.75,2.75,0,1,0,2.75,2.75A2.76,2.76,0,0,0,113.11,205.75Zm0,4.59A1.84,1.84,0,1,1,115,208.5,1.84,1.84,0,0,1,113.11,210.34Z"/>
                    <path class="cls-6" d="M332.61,59.65H247c-6.6,0-12,2.37-12,5.26v16.9"/>
                    <path class="cls-6" d="M217.67,26.24H227c4.38,0,8,2.24,8,5V59.65"/>
                    <path class="cls-6 cls-8" d="M162.33,217.3V244c0,4.7-5.4,8.54-12,8.54H137.89"/>
                    <path class="cls-6" d="M24.33,33.13H56c6.6,0,12,4.35,12,9.67V62.31"/>
                    <path class="cls-6 cls-8" d="M262.48,229h28.86c4.81,0,8.74-5.4,8.74-12V182.49"/>
                    <path class="cls-6 cls-8" d="M171.62,206.66h21a6.32,6.32,0,0,0,6.38-6.23V182.49"/>
                    <path class="cls-6 cls-8" d="M135.48,123.33v71.33c0,6.6,4,12,8.81,12h5.82"/>
                    <path class="cls-6 cls-8" d="M122.72,112.31H80c-6.6,0-12-3.9-12-8.66V79.31"/>
                    <path class="cls-6 cls-8" d="M155.42,112.31H223a12,12,0,0,0,12-12V96.56"/>
                    <path class="cls-6 cls-8" d="M65.48,112.31H45.05c-6.11,0-11.12,5.4-11.12,12v18.5"/>
                    <path class="cls-6 cls-8" d="M235,112.31h4.78c7,0,12.72,5.21,12.72,11.59v93.4"/>
                    <rect class="cls-7 cls-8" x="248.36" y="222.9" width="8.25" height="8.25" rx="4.12" ry="4.12"/>
                    <rect class="cls-7" x="158.2" y="202.54" width="8.25" height="8.25" rx="4.12" ry="4.12"/>
                    <rect class="cls-7" x="230.86" y="85.31" width="8.25" height="8.25" rx="4.12" ry="4.12"/>
                    <rect class="cls-7" x="63.86" y="67.69" width="8.25" height="8.25" rx="4.12" ry="4.12"/>
                </g>
            </g>
        </svg>
    </div>
</template>


<style lang="scss">
    .platform-container{
        max-width: 130px;
    }

    .shadowFrame {
        width: 130px;
        margin-top: 15px;
    }

    .shadow {
        animation: shrink 3s ease-out infinite;
        transform-origin: center center;
        ellipse {
            transform-origin: center center;
        }
    }

    @keyframes shrink {
        0% {
            width: 90%;
            margin: 0 5%;
        }
        50% {
            width: 60%;
            margin: 0 18%;
        }
        100% {
            width: 90%;
            margin: 0 5%;
        }
    }

    .cls-1,.cls-2,.cls-6{fill:none;}

    .cls-1,.cls-4{stroke: #ffffff;}

    .cls-1,.cls-2,.cls-3,.cls-4{stroke-miterlimit:10;}

    .cls-2,.cls-3{stroke: #ffffff;}

    .cls-3,.cls-4{fill: #ffffff;}

    .cls-5{fill: #ffffff;}

    .cls-6{
        stroke: #ffbb00;
        stroke-linejoin:round;
        stroke-width:1.5px;
        stroke-dasharray:3 4;
        animation: dash 6s linear infinite forwards;
    }

    .cls-8 {
        animation-direction: reverse;
    }

    .cls-7{fill: #ffbb00;}

    @keyframes dash {
        to {
            stroke-dashoffset: 100;
        }
    }
</style>

<script>
    export default {
        name: 'iran-network'
    }
</script>
